<custom-app-bar
  [hasCloseButton]="true"
  [closeButtonReturnToThePreviousPage]="false"
  (onClickCloseButton)="close()"
  [hasSafeArea]="false"
></custom-app-bar>
<section class="content">
  <p class="error-message">{{ errorMessage }}</p>
  <button customButton size="large" expand="full" (click)="close()">
    {{ "error_modal.ok" | translate }}
  </button>
</section>
